<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-maximize-2"
  >
    <line x1="15" x2="21" y1="3" y2="3" />
    <line x1="21" x2="21" y1="3" y2="9" />
    
    <line x1="9" x2="3" y1="21" y2="21" />
    <line x1="3" x2="3" y1="21" y2="15" />

    <line x1="21" x2="14" y1="3" y2="10" />
    <line x1="3" x2="10" y1="21" y2="14" />
  </svg>
</template>

<script>
export default {
  name: 'ZoomIcon'
}
</script>
